/* FF Bar v3.7 - Strikkemani 2026-05-01 / 2026-10-28
   Pakke-detection er nu title-basert (Strikk The Look:) - ikke collection-lookup
   v3.7: fri frakt-grensen leses fra data-ff-grense (shop-metafelt strikkemani.fri_frakt_grense via Liquid);
   verdi utenfor vinduet 300-2000 gir 890 (samme vakt som i Liquid, R11; gulvet 690 haandheves i beslutning.py,
   ikke i temaet). Kurvattributtet fri_frakt_grense skrives KUN naar
   MERK_KURV er true (standard false - diagnose, aldri primaer tilordning av ordre til grense). Papirlogikken er uendret. */
(function () {
  'use strict';
  var MERK_KURV = false; // V17: kurvattributtet er AV som standard. true kun etter groenn F25 i begge stillinger.
  var GRENSE_ATTR = 'fri_frakt_grense';
  var GRENSE_MIN_KR = 300;
  var GRENSE_MAKS_KR = 2000;
  var THRESHOLD = readThreshold();
  var grenseAttrSynket = false;
  function readThreshold(){
    var el = document.querySelector('[data-ff-grense]');
    var kr = el ? parseInt(el.getAttribute('data-ff-grense'), 10) : NaN;
    if (!kr || kr < GRENSE_MIN_KR || kr > GRENSE_MAKS_KR) kr = 890;
    return kr * 100;
  }
  var COLLECTION_HANDLES = ['ff-fyll-by-strikkemani', 'ff-fyll-intro'];
  var RECOMMEND_COUNT = 4;
  var NO_UPSELL_TAG = 'NO_UPSELL';
  var TITLE_BLACKLIST_PREFIX = '00-';
  var PAKKE_TITLE_PREFIX = 'Strikk The Look:';
  var OPPSKRIFT_VARIANT_ID = 8687201255484;
  var REMOVED_KEY = 'ff-oppskrift-removed';
  var RELOAD_FLAG = 'ff-just-reloaded';
  var cache = { products: null, fetchedAt: 0, ttl: 5 * 60 * 1000 };
  var lastState = null;
  var ourLastUpdate = 0;

  function isCartPage(){var p=window.location.pathname;return p==='/cart'||p==='/cart/';}
  function reloadCartPageOnce(){
    if(!isCartPage())return;
    try{
      if(sessionStorage.getItem(RELOAD_FLAG)==='1'){sessionStorage.removeItem(RELOAD_FLAG);return;}
      sessionStorage.setItem(RELOAD_FLAG,'1');
    }catch(e){}
    window.location.reload();
  }
  function clearReloadFlag(){try{sessionStorage.removeItem(RELOAD_FLAG);}catch(e){}}

  function formatNok(o) { return (o/100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,' ')+' kr'; }
  function escapeHtml(s){return String(s||'').replace(/[&<>"']/g,function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;'})[c];});}

  function isLookPackage(item){
    var t = item.product_title || item.title || '';
    if(t.indexOf(PAKKE_TITLE_PREFIX) === 0) return true;
    // Case-insensitive fallback
    if(t.toLowerCase().indexOf(PAKKE_TITLE_PREFIX.toLowerCase()) === 0) return true;
    return false;
  }

  function fetchEligibleProducts() {
    if (cache.products && Date.now()-cache.fetchedAt<cache.ttl) return Promise.resolve(cache.products);
    var ps = COLLECTION_HANDLES.map(function(h){
      return fetch('/collections/'+h+'/products.json?limit=50').then(function(r){return r.ok?r.json():{products:[]};}).catch(function(){return {products:[]};});
    });
    return Promise.all(ps).then(function(rs){
      var all=[]; rs.forEach(function(d){if(d.products)all.push.apply(all,d.products);});
      var seen={},u=all.filter(function(p){if(seen[p.id])return false;seen[p.id]=true;return true;});
      var f=u.filter(function(p){
        var t=(p.tags||[]).map(function(x){return String(x).toUpperCase();});
        if(t.indexOf(NO_UPSELL_TAG)!==-1)return false;
        if((p.title||'').indexOf(TITLE_BLACKLIST_PREFIX)===0)return false;
        var v=(p.variants||[]).find(function(x){return x.available&&x.price>0;});
        return !!v;
      });
      cache.products=f; cache.fetchedAt=Date.now(); return f;
    });
  }

  function getDesignKey(t){
    if(!t)return '_unknown';
    var m=t.match(/Strikk The Look:\s*([A-Za-zÀ-ſ]+)/i);
    if(m)return m[1].toLowerCase();
    return (t.replace(/^[\s\-]+/,'').split(/[\s\-]/)[0]||'_unknown').toLowerCase();
  }

  function hasMultipleVariants(p){
    var v=p.variants||[];
    if(v.length<2){if(v.length===1&&v[0].title&&v[0].title!=='Default Title')return true;return false;}
    return true;
  }

  function pickRecommendations(products,gapOre){
    var gN=gapOre/100;
    var all=products.map(function(p){
      var v=(p.variants||[]).find(function(x){return x.available&&x.price>0;});
      if(!v)return null;
      return {p:p,v:v,priceNok:parseFloat(v.price)};
    }).filter(Boolean);
    var fams={};
    all.forEach(function(s){var k=getDesignKey(s.p.title);if(!fams[k])fams[k]=[];fams[k].push(s);});
    var fp=Object.keys(fams).map(function(k){
      var f=fams[k];
      var og=f.filter(function(s){return s.priceNok>=gN;});
      if(og.length)return og.sort(function(a,b){return a.priceNok-b.priceNok;})[0];
      return f.sort(function(a,b){return b.priceNok-a.priceNok;})[0];
    });
    var og=fp.filter(function(s){return s.priceNok>=gN;}).sort(function(a,b){return a.priceNok-b.priceNok;});
    if(og.length>=RECOMMEND_COUNT)return og.slice(0,RECOMMEND_COUNT);
    var ug=fp.filter(function(s){return s.priceNok<gN;}).sort(function(a,b){return b.priceNok-a.priceNok;});
    return og.concat(ug).slice(0,RECOMMEND_COUNT);
  }

  function updateTopBar(o){
    var b=document.querySelector('.ff-bar'); if(!b)return;
    var t=b.querySelector('.ff-bar__text'); if(!t)return;
    if(o===0){b.classList.remove('ff-bar--unlocked');t.innerHTML='Fri frakt over <span class="ff-bar__amount">'+formatNok(THRESHOLD)+'</span>';}
    else if(o>=THRESHOLD){b.classList.add('ff-bar--unlocked');t.textContent='Fri frakt aktivert';}
    else{b.classList.remove('ff-bar--unlocked');t.innerHTML='Du mangler <span class="ff-bar__amount">'+formatNok(THRESHOLD-o)+'</span> til fri frakt';}
  }

  function updateCartDrawer(o){
    var w=document.querySelector('.ff-progress'); if(!w)return;
    var t=w.querySelector('.ff-progress__text');
    var f=w.querySelector('.ff-progress__fill');
    var rb=document.querySelector('.ff-recommend');
    var pct=Math.min(100,(o/THRESHOLD)*100);
    if(f){f.style.width=pct+'%'; f.style.backgroundColor=(o>=THRESHOLD?'#1f6e3a':'#e51b23');}
    if(o>=THRESHOLD){
      w.classList.add('ff-progress--unlocked');
      if(t)t.textContent='Fri frakt aktivert - nyt strikkingen.';
      if(rb)rb.style.display='none'; return;
    }
    w.classList.remove('ff-progress--unlocked');
    var gap=THRESHOLD-o;
    if(t){if(o===0)t.innerHTML='Fri frakt over <span class="ff-progress__amount">'+formatNok(THRESHOLD)+'</span>';
      else t.innerHTML='Du mangler <span class="ff-progress__amount">'+formatNok(gap)+'</span> til fri frakt';}
    if(o>0&&rb){
      fetchEligibleProducts().then(function(ps){
        var picks=pickRecommendations(ps,gap);
        renderRecommendations(rb,picks);
        rb.style.display=picks.length?'block':'none';
      });
    }else if(rb){rb.style.display='none';}
  }

  function renderRecommendations(box,picks){
    if(!picks.length){box.innerHTML='';return;}
    var html='<h3 class="ff-recommend__heading">Velg en til kurven</h3><ul class="ff-recommend__list">';
    picks.forEach(function(s){
      var src=''; if(s.p.images&&s.p.images[0])src=(s.p.images[0].src||s.p.images[0]);
      var img=src?'<img class="ff-recommend__image" src="'+src+'" alt="'+escapeHtml(s.p.title)+'" loading="lazy">':'';
      var multi=hasMultipleVariants(s.p);
      var cta=multi?'<a class="ff-recommend__cta" href="/products/'+s.p.handle+'">Velg størrelse</a>':'<button class="ff-recommend__cta" data-variant-id="'+s.v.id+'" data-add-to-cart="1">Legg i kurv</button>';
      html+='<li class="ff-recommend__item"><a class="ff-recommend__link" href="/products/'+s.p.handle+'">'+img+'<div class="ff-recommend__info"><p class="ff-recommend__title">'+escapeHtml(s.p.title)+'</p><p class="ff-recommend__price">'+s.priceNok.toFixed(0)+' kr</p></div></a>'+cta+'</li>';
    });
    html+='</ul>'; box.innerHTML=html;
    box.querySelectorAll('[data-add-to-cart="1"]').forEach(function(btn){
      btn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();addToCart(btn.getAttribute('data-variant-id'),1);});
    });
  }

  function addToCart(vid,qty){
    ourLastUpdate=Date.now();
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(vid,10),quantity:qty||1}]})})
      .then(function(r){if(r.ok)document.dispatchEvent(new CustomEvent('ff-bar:cart-updated'));}).catch(function(){});
  }

  function changeCartLine(key,qty){
    ourLastUpdate=Date.now();
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
  }

  function syncOppskrift(cart){
    // Title-basert pakke-detection: "Strikk The Look:" prefix
    var uniqueIds={}; var oppItem=null;
    cart.items.forEach(function(it){
      if(isLookPackage(it))uniqueIds[it.product_id]=true;
      if(it.variant_id===OPPSKRIFT_VARIANT_ID)oppItem=it;
    });
    var pakkeCount=Object.keys(uniqueIds).length;
    var oppCount=oppItem?oppItem.quantity:0;

    if(lastState&&lastState.pakkeCount===pakkeCount&&oppCount<lastState.oppskriftCount){
      if(Date.now()-ourLastUpdate>1500){try{sessionStorage.setItem(REMOVED_KEY,'1');}catch(e){}}
    }
    lastState={pakkeCount:pakkeCount,oppskriftCount:oppCount};

    var userRemoved=false; try{userRemoved=sessionStorage.getItem(REMOVED_KEY)==='1';}catch(e){}

    if(pakkeCount===0&&oppCount===0){try{sessionStorage.removeItem(REMOVED_KEY);}catch(e){}userRemoved=false;}

    function doAndReload(promise){
      return promise.then(function(){if(isCartPage())reloadCartPageOnce();});
    }

    if(pakkeCount===0&&oppCount>0&&oppItem){
      return doAndReload(changeCartLine(oppItem.key,0).then(function(){renderNotice(0,0,false);}));
    }
    if(pakkeCount===0){renderNotice(0,0,false);clearReloadFlag();return Promise.resolve();}
    if(userRemoved&&oppCount===0){renderNotice(0,pakkeCount,true);clearReloadFlag();return Promise.resolve();}
    if(oppCount===pakkeCount){renderNotice(oppCount,pakkeCount,false);clearReloadFlag();return Promise.resolve();}
    if(oppCount===0){
      return doAndReload(addToCart(OPPSKRIFT_VARIANT_ID,pakkeCount).then(function(){renderNotice(pakkeCount,pakkeCount,false);}));
    }
    if(oppItem){
      return doAndReload(changeCartLine(oppItem.key,pakkeCount).then(function(){renderNotice(pakkeCount,pakkeCount,false);}));
    }
    return Promise.resolve();
  }

  function renderNotice(oppCount,pakkeCount,reactivateMode){
    var n=document.querySelector('.ff-oppskrift-notice'); if(!n)return;
    if(reactivateMode){
      n.setAttribute('data-mode','reactivate');
      n.classList.add('ff-oppskrift-notice--reactivate');
      n.innerHTML='<span class="ff-oppskrift-notice__text">Du har fjernet papirmønster fra kurven.</span><button type="button" class="ff-oppskrift-notice__action" data-action="reactivate">Aktiver igjen</button>';
      n.style.display='flex';
      attachActionHandler();
      return;
    }
    if(oppCount>0){
      n.setAttribute('data-mode','added');
      n.classList.remove('ff-oppskrift-notice--reactivate');
      n.innerHTML='<span class="ff-oppskrift-notice__text">Vi har lagt til <strong class="ff-oppskrift-notice__count">'+oppCount+'</strong> papirmønster — ett per strikkepakke.</span><button type="button" class="ff-oppskrift-notice__action" data-action="remove">Fjern</button>';
      n.style.display='flex';
      attachActionHandler();
      return;
    }
    n.style.display='none';
  }

  function attachActionHandler(){
    var n=document.querySelector('.ff-oppskrift-notice'); if(!n)return;
    var btn=n.querySelector('.ff-oppskrift-notice__action'); if(!btn||btn.dataset.bound)return;
    btn.dataset.bound='1';
    btn.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();
      var action=btn.getAttribute('data-action');
      if(action==='remove'){
        try{sessionStorage.setItem(REMOVED_KEY,'1');}catch(e2){}
        fetch('/cart.js').then(function(r){return r.ok?r.json():null;}).then(function(c){
          if(!c)return;
          var it=c.items.find(function(i){return i.variant_id===OPPSKRIFT_VARIANT_ID;});
          if(!it)return;
          return changeCartLine(it.key,0).then(function(){
            if(isCartPage()){
              try{sessionStorage.removeItem(RELOAD_FLAG);}catch(e3){}
              window.location.reload();
            }else{
              document.dispatchEvent(new CustomEvent('ff-bar:cart-updated'));
            }
          });
        });
      }else if(action==='reactivate'){
        try{sessionStorage.removeItem(REMOVED_KEY);sessionStorage.removeItem(RELOAD_FLAG);}catch(e2){}
        if(isCartPage())window.location.reload();
        else refreshFromCart();
      }
    });
  }

  // v3.7: merk kurven med gjeldende grense (kroner) som kurvattributt, saa ordren baerer customAttributes.fri_frakt_grense.
  // Bak MERK_KURV (standard false): med false gjoer funksjonen ingenting og ingen /cart/update.js sendes.
  // Med true: skrives hoyst en gang per sidevisning, aldri for tom kurv, aldri naar verdien allerede stemmer. Ingen lokke:
  // flagget settes FOR kallet, saa fetch-patchens refreshFromCart etterpaa ikke skriver igjen.
  function syncGrenseAttributt(c){
    if(!MERK_KURV)return Promise.resolve();
    if(grenseAttrSynket||!c||!c.items||!c.items.length)return Promise.resolve();
    var vil=String(THRESHOLD/100);
    if(c.attributes&&String(c.attributes[GRENSE_ATTR])===vil){grenseAttrSynket=true;return Promise.resolve();}
    grenseAttrSynket=true;
    var a={}; a[GRENSE_ATTR]=vil;
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:a})})
      .then(function(r){if(!r.ok)grenseAttrSynket=false;}).catch(function(){grenseAttrSynket=false;});
  }

  function refreshFromCart(){
    return fetch('/cart.js').then(function(r){return r.ok?r.json():null;}).then(function(c){
      if(!c)return;
      updateTopBar(c.total_price||0);
      updateCartDrawer(c.total_price||0);
      attachActionHandler();
      return syncOppskrift(c).then(function(){return syncGrenseAttributt(c);});
    }).catch(function(){});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refreshFromCart);
  else refreshFromCart();
  document.addEventListener('cart:updated',refreshFromCart);
  document.addEventListener('ff-bar:cart-updated',refreshFromCart);

  var of=window.fetch;
  window.fetch=function(){
    var args=arguments;
    var url=typeof args[0]==='string'?args[0]:(args[0]&&args[0].url)||'';
    var p=of.apply(this,args);
    if(/\/cart\/(add|change|update|clear)/.test(url))p.then(function(){setTimeout(refreshFromCart,150);}).catch(function(){});
    return p;
  };

  function resetOppskrift(){
    try{sessionStorage.removeItem(REMOVED_KEY);sessionStorage.removeItem(RELOAD_FLAG);}catch(e){}
    console.log('FF-bar: oppskrift-flagget nullstilt.');
    if(isCartPage())window.location.reload();
  }
  window.ffBar={refresh:refreshFromCart,threshold:THRESHOLD,grenseKr:THRESHOLD/100,merkKurv:MERK_KURV,reset:resetOppskrift};
})();
